import { createGlobalStyle } from "../Themes";

export default createGlobalStyle`
  body {
    user-select: none !important;
  }
`;
